import authAxios from './axiosConfigAuth'
import customAxios from './axiosConfig'

const AuthService = {
  getAccesToken (data) {
    return authAxios.post(window.Urls['accounts_api_access_token'](), data)
  },
  getResetLink (data) {
    return customAxios.post(window.Urls['user_send_reset_link'](), data)
  },
  resetPassword (data) {
    return customAxios.post(window.Urls['user_reset_password'](), data)
  },
  sendThirdPartyCredentials (data) {
    const api_url = window.Urls['third_party_credentials']()
    return customAxios.post(api_url, data)
  }
}

export default AuthService
